import { render, staticRenderFns } from "./dialog-add-inventory.vue?vue&type=template&id=2bde3809&scoped=true&"
import script from "./dialog-add-inventory.vue?vue&type=script&lang=js&"
export * from "./dialog-add-inventory.vue?vue&type=script&lang=js&"
import style0 from "./dialog-add-inventory.vue?vue&type=style&index=0&id=2bde3809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde3809",
  null
  
)

export default component.exports